const initialState = {
	loading: false,
	pageHeaderText: '',
	alert: null,
	currentDialogToggle: false,
	unreadAlertAmount: 0,
	tablesState: {
		users: {
			searchQuery: '',
			sortBy: [{
				id: 'createdAt',
				desc: true,
			}],
			page: 0,
		},
		organizations: {
			sortBy: [{
				id: 'name',
				desc: false,
			}],
			page: 0,
		},
	}
};

const commonReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_LOADING':
			return {
				...state,
				loading: action.payload.value,
			};
		case 'SET_ALERT':
			return {
				...state,
				alert: action.payload.value
			};
		case 'SET_PAGE_HEADER_TEXT':
			return {
				...state,
				pageHeaderText: action.payload.value
			};
		case 'TOGGLE_CURRENT_DIALOG':
			return {
				...state,
				currentDialogToggle: !state.currentDialogToggle,
			};
		case 'SET_TABLE_STATE':
			return {
				...state,
				tablesState: {
					...state.tablesState,
					[action.payload.value.table]: action.payload.value.state
				}
			};
		case 'SET_UNREAD_ALERT_AMOUNT':
			return {
				...state,
				unreadAlertAmount: action.payload.value,
			};
		default:
			return state;
	}
};


export const setLoadingActionCreator = value => ({
	type: 'SET_LOADING',
	payload: {
		value
	}
});

export const setAlertActionCreator = value => ({
	type: 'SET_ALERT',
	payload: {
		value
	}
});

export const setPageHeaderTextActionCreator = value => ({
	type: 'SET_PAGE_HEADER_TEXT',
	payload: {
		value
	}
});

export const rerenderCurrentDialogActionCreator = () => ({
	type: 'TOGGLE_CURRENT_DIALOG',
	payload: {},
});

export const setTableStateActionCreator = value => ({
	type: 'SET_TABLE_STATE',
	payload: {
		value
	}
});

export const setUnreadAlertAmountActionCreator = value => ({
	type: 'SET_UNREAD_ALERT_AMOUNT',
	payload: {
		value,
	},
});

export default commonReducer;
